import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-giftcards',
  templateUrl: './giftcards.component.html',
  styleUrls: ['./giftcards.component.sass']
})
export class GiftcardsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
